module.exports = __webpack_public_path__ + "img/la-icon.f76bc61d.png";